import { Theme } from '@mui/material';
import { CommonComponents } from '../types';

export function getPrivatePickersYear(theme: Theme): CommonComponents {
  return {
    styleOverrides: {
      button: {
        borderRadius: theme.shape.borderRadiusSm,
      },
    },
  };
}
